import { render, staticRenderFns } from "./AIConfig.vue?vue&type=template&id=a8d0ecee&scoped=true&lang=pug"
import script from "./AIConfig.vue?vue&type=script&lang=js"
export * from "./AIConfig.vue?vue&type=script&lang=js"
import style0 from "./AIConfig.vue?vue&type=style&index=0&id=a8d0ecee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8d0ecee",
  null
  
)

export default component.exports